<template>
    <div>
        <div class="summary-table-container">
            <div class="summary-table-container__title">Summary</div>
            <div class="summary-servers-table">
                <Table
                    :columns="[
                        'Type',
                        'Provider',
                        'Game name',
                        'Players',
                        'Peak (24)',
                        'Expiration',
                        'Running time',
                    ]"
                    :data="
                        filteredServers && filteredServers.length > 0
                            ? filteredServers.slice(0, 3)
                            : null
                    "
                    :cell-style="
                        'display: grid; grid-template-columns: 2fr 2fr 3fr 2fr 2fr 2fr 2fr; grid-template-rows: 4rem;'
                    "
                    :data-elements="[
                        'type',
                        'provider',
                        'gameName',
                        'players',
                        'peak',
                        'expiration',
                        'runningTime',
                    ]"
                    :is-loading="loading"
                    :no-title="true"
                />
            </div>

            <button-default
                class="summary-data-table__view-all"
                :color="'veryDarkBlue'"
                :style="veryDarkBlueButton"
                :link="ALL_SERVERS_PAGE_NAME"
                :component-nav="true"
                :svg="true"
                :text="'View All'"
                :name="'view_all_arrow'"
                :svg-style="'width: 12px; fill: white; margin: auto 2px;'"
            />
        </div>
    </div>
</template>

<script>
import { ALL_SERVERS_PAGE_NAME } from '@/router/pageNameConstants.js';

import { mapGetters } from 'vuex';
import Button from '@/components/common/Button';
import Table from '@/components/common/Table.vue';

export default {
    name: 'Summary',
    components: { 'button-default': Button, Table },
    data() {
        return {
            ALL_SERVERS_PAGE_NAME,
            veryDarkBlueButton: {
                width: '94px',
                height: '29px',
                fontFamily: '$palanquin-font',
                fontSize: '13px',
                fontWeight: '400',
                letterSpacing: '0.05px',
                margin: '28px 5rem auto auto',
            },
            tableData: [],
        };
    },
    computed: {
        ...mapGetters('module_servers', {
            loading: 'getLoading',
            filteredServers: 'getFilteredServers',
        }),
    },
};
</script>

<style scoped lang="scss">
.summary-table-container {
    &__title {
        margin: auto auto 2rem 3rem;
        width: 308px;
        height: 44px;
        color: $blue-main;
        font-family: $istok-font;
        font-size: 36px;
        font-weight: 700;
        letter-spacing: 0.57px;
        line-height: 53px;
        @media (min-width: $xxs-up) and (max-width: $xl-up) {
            margin: auto auto 2rem 3rem;
            width: 212px;
            height: 22px;
            font-size: 28px;
            font-weight: 700;
            letter-spacing: 0.28px;
            line-height: 53px;
        }
    }
}
.summary-servers-table {
    &__view-all {
        margin-right: 15rem;
        @media (max-width: $xl-up) {
            margin-right: -6rem;
        }
    }
}
</style>
<style lang="scss">
.summary-servers-table {
    .generic-table {
        width: 90%;
        margin-left: 50px;
        @media (max-width: $xs-up) {
            margin: 0;
            margin: 0 auto;
        }

        .cont {
            @media (max-width: $sm-up) {
                width: 1100px;
            }

            .rowCell {
                @media (max-width: $xs-up) {
                    min-width: 100px;
                }
            }
        }
    }
}
</style>
